import { arrayOf } from 'prop-types';
import React from 'react';

import { basicCampaignShape, optionShape } from '../../prop-types';
import CampaignCard from '../CampaignCard';
import { allStatusesEnum } from '../constants';
import {
  getCoInvest,
  getFreeService,
  getNetClientBudgetExternal,
  getOpenBudget,
  getSpendableBudget,
  getWkzBudget,
} from '../utils/get-budgets';
import LaneBudgets from './LaneBudgets';

class CampaignLane extends React.PureComponent {
  render() {
    const { category, campaigns } = this.props;
    const openBudget = getOpenBudget(campaigns);
    const netClientBudgetExternal = getNetClientBudgetExternal(campaigns);
    const coInvest = getCoInvest(campaigns);
    const freeService = getFreeService(campaigns);
    const wkzBudget = getWkzBudget(campaigns);
    const spendableBudget = getSpendableBudget(campaigns);

    return (
      <div>
        <div className="c-progress_select--small bg-primary text-center">
          {category.label}
          <small className="pl-1">({campaigns.length})</small>
        </div>
        {!!campaigns.length &&
          category.value !== allStatusesEnum.ENDED.value && (
            <LaneBudgets
              openBudget={openBudget}
              netClientBudgetExternal={netClientBudgetExternal}
              coInvest={coInvest}
              freeService={freeService}
              wkzBudget={wkzBudget}
              spendableBudget={spendableBudget}
            />
          )}
        <div className="c-swimlanes-card-pool">
          {campaigns.map(campaign => (
            <CampaignCard key={campaign.id} campaign={campaign} />
          ))}
        </div>
      </div>
    );
  }
}

CampaignLane.propTypes = {
  category: optionShape.isRequired,
  campaigns: arrayOf(basicCampaignShape.isRequired).isRequired,
};

export default CampaignLane;
